import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { ChipTypeEnum } from './models/chip-type.enum';
import { IconConfig } from './models/icon-config.model';
import { PlatformService } from '@panamax/app-state';
import { PopoverController } from '@ionic/angular';
import { UsfChipPopoverOptions } from './models/usf-chip-popover-options.model';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-usf-chip',
  templateUrl: './usf-chip.component.html',
  styleUrls: ['./usf-chip.component.scss'],
})
export class UsfChipComponent implements OnDestroy {
  @Input() type: ChipTypeEnum;
  @Input() clickable = false;
  @Input() iconConfig: IconConfig = {
    iconWidth: 0.8125,
    iconHeight: 0.8125,
    color: '#000',
  };
  @Input() iconUrl: string;
  @Input() popoverOptions: UsfChipPopoverOptions;
  @Input() textColor = '';
  @Input() backgroundColor = '';
  @Output() clickEmitter = new EventEmitter<boolean>();
  @Output() imageError = new EventEmitter<void>();

  triggerId: string = 'popover-trigger-' + uuidv4();
  chipType = ChipTypeEnum;
  productPillPopover: HTMLIonPopoverElement;
  isPopoverOpening = false;
  pillHoverTimeout: any;
  pillHoverDelay = 100;
  hidePill = false;
  destroyed = false;
  currentOperationId = 0;

  constructor(
    readonly platformService: PlatformService,
    private popoverController: PopoverController,
  ) {}

  ngOnDestroy(): void {
    this.destroyed = true;
    this.clearPillHoverTimeout();
    this.closeProductPillPopover();
  }

  onProductPillClick($event: any) {
    if (!!this.popoverOptions && this.platformService.isTouch.value) {
      this.openProductPillPopover($event);
    } else {
      if (this.clickable) {
        this.clickEmitter.emit($event);
      }
    }
  }

  handleProductPillMouseOver($event: Event) {
    if (this.isPopoverOpening || this.productPillPopover) {
      this.closeProductPillPopover();
      return;
    }

    this.clearPillHoverTimeout();

    // Set a small delay before opening to prevent rapid hover in/out

    this.pillHoverTimeout = setTimeout(() => {
      if (this.destroyed) {
        // Prevent opening popover if component is destroyed
        return;
      }
      this.isPopoverOpening = true;
      this.openProductPillPopover($event);
    }, this.pillHoverDelay);
  }

  clearPillHoverTimeout() {
    if (this.pillHoverTimeout) {
      clearTimeout(this.pillHoverTimeout);
    }
  }

  async openProductPillPopover(ev: any) {
    if (!ev) {
      return;
    }

    const operationId = ++this.currentOperationId;

    if (this.destroyed) {
      this.isPopoverOpening = false;
      return;
    }

    try {
      if (!!this.popoverOptions && !this.popoverOptions.inline) {
        const newPopover = await this.popoverController.create({
          ...this.popoverOptions,
          event: ev,
        });

        if (operationId !== this.currentOperationId) {
          await newPopover.dismiss();
          return;
        }

        if (this.destroyed) {
          await newPopover.dismiss();
          return;
        }

        this.productPillPopover = newPopover;
        await this.productPillPopover.present();
      }
    } catch (error) {
    } finally {
      this.isPopoverOpening = false;
    }
  }

  closeProductPillPopover() {
    if (!!this.popoverOptions && !this.popoverOptions.inline) {
      this.currentOperationId++;
      this.isPopoverOpening = false;
      this.clearPillHoverTimeout();

      if (this.productPillPopover) {
        this.productPillPopover
          .dismiss()
          .then(() => {})
          .catch(error =>
            console.error('[USF CHIP] - Error dismissing:', error),
          )
          .finally(() => {
            this.productPillPopover = undefined;
          });
      }
    }
  }

  onImageLoadError() {
    this.hidePill = true;
    this.imageError.emit();
  }
}
